import { render, staticRenderFns } from "./SysConfig.vue?vue&type=template&id=3db46970&scoped=true"
import script from "./SysConfig.vue?vue&type=script&lang=js"
export * from "./SysConfig.vue?vue&type=script&lang=js"
import style0 from "./SysConfig.vue?vue&type=style&index=0&id=3db46970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db46970",
  null
  
)

export default component.exports